import { render, staticRenderFns } from "./MemberAuthorizations.vue?vue&type=template&id=76e15a4d"
import script from "./MemberAuthorizations.vue?vue&type=script&lang=js"
export * from "./MemberAuthorizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports